jQuery(document).ready(function ($) {
	$(document).on('change', '#alps-latest-reviews-sort', function () {
		var order_by = $(this).val();
		$('.alps-latest-reviews-loading').css('display', 'flex');
		var data = {
			number_of_reviews: $('.alps-reviews-showcase').attr(
				'data-number_of_reviews'
			),
			order_by: order_by,
			action: $('.alps-reviews-showcase').attr('data-action'),
		};
		$('.alps-reviews-showcase').empty();
		$.post(
			ajaxObject.ajaxUrl,
			data,
			function (response, textStatus, xhr) {
				$('.alps-reviews-showcase').append(response);
				$('.alps-latest-reviews-loading').css('display', 'none');
			},
			'json'
		);
	});
	function loadLatestPosts(page) {
		$('.alps-latest-reviews-loading').css('display', 'flex');
		var data = {
			number_of_reviews: $('.alps-reviews-showcase').attr(
				'data-number_of_reviews'
			),
			order_by: $('.alps-latest-reviews-sort').val(),
			action: $('.alps-reviews-showcase').attr('data-action'),
			page: page,
		};
		$('.alps-reviews-showcase').empty();
		$.post(ajaxObject.ajaxUrl, data, function (response) {
			if (response) {
				$('.alps-reviews-showcase').append(response);
				$('.alps-latest-reviews-loading').css('display', 'none');
			}
		});
	}
	$(document).on(
		'click',
		'.alps-latest-reviews-pagination .page-numbers',
		function (e) {
			e.preventDefault();
			var page = parseInt($(this).text(), 10);
			var parent = $(this).closest('.alps-latest-reviews-pagination');
			var current = parent.find('.current');
			if ($(this).hasClass('next')) {
				var page = parseInt(current.text(), 10) + 1;
			}
			if ($(this).hasClass('prev')) {
				var page = parseInt(current.text(), 10) - 1;
			}
			loadLatestPosts(page);
		}
	);
	function loadCoursesReviews(page) {
		$('.alps-single_course_reviews-loading').css('display', 'flex');
		var data = {
			location_id: $('.wp-block-alps-golf-reviews-sync-mbg-reviews').attr(
				'data-number_of_reviews'
			),
			qvalue: $('.wp-block-alps-golf-reviews-sync-mbg-reviews').attr(
				'data-qvalue_field'
			),
			action: 'render_single_course_reviews',
			page: page,
		};
		$('.wp-block-alps-golf-reviews-sync-mbg-reviews').empty();
		$.post(ajaxObject.ajaxUrl, data, function (response) {
			if (response) {
				$('.wp-block-alps-golf-reviews-sync-mbg-reviews').append(response);
				$('.alps-single_course_reviews-loading').css('display', 'none');
			}
		});
	}
	$(document).on(
		'click',
		'.alps-course-reviews-pagination .page-numbers',
		function (e) {
			e.preventDefault();
			var page = parseInt($(this).text(), 10);
			var parent = $(this).closest('.alps-course-reviews-pagination');
			var current = parent.find('.current');
			if ($(this).hasClass('next')) {
				var page = parseInt(current.text(), 10) + 1;
			}
			if ($(this).hasClass('prev')) {
				var page = parseInt(current.text(), 10) - 1;
			}
			loadCoursesReviews(page);
		}
	);
});
